module.exports = __webpack_public_path__ + "static/media/chinenye_eneh.49974fca.png";